<template>
  <div id="mydialog">
    <div class="mask" v-show="show"></div>
    <div class="cont" :class="show?'cssshow':''" :style="thestyle">
      <div class="header" >
        <div class="imgcon" @click="canceldialog"><img src="../../../assets/image/close.png"/></div>
        <img v-if="icon=='zfb'" class="ic" src="../../../assets/image/zfb1.png"/>
        <img v-if="icon=='wx'" class="ic" src="../../../assets/image/wxpay.png"/>
        <div class="clear"></div>
      </div>

      <div class="zdy">
        <slot></slot>
      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue';
  import { Button,Icon } from 'vant';
  Vue.use(Button);
  Vue.use(Icon);
  export default {
    name: 'mydialog',
    props:["show","thestyle",'icon'],
    data () {
      return {
      }
    },

    methods:{
      canceldialog(){
        this.$emit('cancel')
      },
    }

  }
</script>

<style scoped lang="scss">
  #mydialog{

    .mask{
      position: fixed;
      z-index: 10;
      background-color: #000000;
      opacity: 0.5;
      width: 100%;
      height:100%;
      top:0;
    }
    .cont{
      transform: scale(0,0);
      transition: 0.2s;
      &.cssshow{
        transform: scale(1,1);
      }

      z-index: 11;
      background: #ffffff;
      img{display: inline-block;}
      border-radius: 0.5rem;
      position: absolute;
      top:20%;
      width: 90%;
      margin-left: 5%;
      .header{
        .ic{
          position: absolute;
          top:0.7rem;
          left:0.7rem;
          width: 1.6rem;
        }
        .imgcon{
          position: absolute;
          right: 0;
          padding:0.3rem 0.3rem 0 0.3rem;
          background: #ffffff;
          margin-top: -1rem;
          float: right;
          margin-right: 1.2rem;
          border-top-left-radius: 50%;
          border-top-right-radius: 50%;
          img{
            display: inline-block;
            width: 1.5rem;
            height:1.5rem;
          }
        }
      }
      .zdy{
      }
    }



  }
</style>



// WEBPACK FOOTER //
// src/components/routerPages/pay/Mydialog.vue